import type { Id, Order } from '@hero/schema';
import { useTranslation } from 'react-i18next';
import { useTransactionOrdersApi } from '@hero/api-hooks';
import { getObjectId } from '@hero/schema';
import { SharedList } from '../../../app/List/List';
import { OrderCard } from '../../Order/Card/OrderCard';
import { useOrderDrawerStore } from '@hero/hooks-shared';

export interface TransactionOrdersTabProps {
  transactionId: Id;
  displayForUser: 'customer' | 'carrier';
}

export function TransactionOrdersTab({
  transactionId,
  displayForUser,
}: TransactionOrdersTabProps) {
  const { t } = useTranslation(['m-payment']);
  const openOrderDrawer = useOrderDrawerStore(s => s.open);

  const query = useTransactionOrdersApi(
    { transactionId: getObjectId(transactionId) },
    { enabled: !!transactionId },
  );

  const handleOrderClick = (order: Order) => {
    openOrderDrawer(String(order._id));
  };

  return (
    <SharedList<Order>
      query={query}
      emptyMessage={t('m-payment:transaction.drawer.orders.no_orders')}
      className="gap-3 p-4"
      renderItem={order => (
        <OrderCard
          order={order}
          displayForUser={displayForUser}
          onClick={handleOrderClick}
        />
      )}
    />
  );
}
